export const SERVER_URL: string = "https://godaddy.roxpublicidade.com.br/campinagrill/api/";
//export const SERVER_URL: string = "https://www.roxpublicidade.com.br/campinagrill/api/";
export const HEADERS: {}        = { "Content-Type": "application/json" , 'X-API-KEY': '9fe012b2-27f3-40fc-aa47-a71535852cb5'};
export const API_TOKEN: string  = '9fe012b2-27f3-40fc-aa47-a71535852cb5';



// WEBPACK FOOTER //
// ./src/config/contants.ts